module.exports = __webpack_public_path__ + "ca1ae723307b1435e1885e8b8a8ebf6d.png";